import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/public/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    canLoad: [AuthGuard],
    loadChildren: () =>
      import('./modules/private/dashboard/dashboard.module')
        .then(m => m.DashboardModule)
  },
  {
    path: 'consultation',
    canLoad: [AuthGuard],
    loadChildren: () =>
      import('./modules/private/consultation/consultation.module').then(m => m.ConsultationModule)
  },

];
@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
